import React, { useState, useEffect, useCallback, useContext } from 'react'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import CommonScreen from 'admin/component/CommonScreen'
import { dateCol, strCol } from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import {
  deleteWind2Lockcheck,
  getWind2LockDays,
  getWind2Lockcheck,
  updateWind2LockDays,
  updateWind2Lockcheck,
  wind2AllPlant,
} from 'api/pgads'
import { modifiedDateCol, modifierCol } from 'core/HeaderColTypeProps'
import { Label } from 'core/screen-util'
import { Button, DatePicker, InputNumber, Select } from 'antd'
import moment from 'moment'
import R from 'ramda'

import { ErrorContext } from 'context'

const title = 'Wind Lock Management'

const Wind2LockCheck = ({ apiTargetInfo }) => {
  const [insertEvent, setInsertEvent] = useState(false)
  const [plantList, setPlantList] = useState([])
  const [entityPlantMap, setEntityPlantMap] = useState({})
  const [PlantIdMap, setPlantIdMap] = useState({})
  // const [entityIdNameMap, setEntityIdNAmeMap] = useState({})
  const [lockOutDays, setLockOutDays] = useState(120)
  const [enableForUpdate, setIsenableForUpdate] = useState(false)
  const { setError } = useContext(ErrorContext)
  const retrieveDays = useCallback(
    _ => {
      getWind2LockDays(apiTargetInfo).fork(
        _ => _,
        data => {
          setLockOutDays((data[0] && data[0].lockOutDays) || 120)
        }
      )
    },
    [apiTargetInfo]
  )
  useEffect(
    _ => {
      retrieveDays()
      // getWind2Entity(apiTargetInfo).fork(
      //   _ => _,
      //   data => {
      //     setEntityIdNAmeMap(
      //       R.compose(
      //         R.fromPairs,
      //         R.map(d => [d.entityId, d.entityName])
      //       )(data)
      //     )
      //   }
      // )
      wind2AllPlant(apiTargetInfo).fork(
        _ => _,
        data => {
          setEntityPlantMap(
            R.compose(
              R.fromPairs,
              R.map(d => [d.plantId, d.entityId])
            )(data)
          )
          setPlantIdMap({
            ALL: 'ALL',
            ...R.compose(
              R.fromPairs,
              R.map(d => [d.plantId, d.plantId + '-' + d.plantName])
            )(data),
          })
          setPlantList(
            R.sortBy(R.compose(R.toLower, R.prop('plantName')))(data)
          )
        }
      )
    },
    [apiTargetInfo, retrieveDays]
  )

  const InsertComp = ({ insertData = {}, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '200px 150px 100px 200px auto auto auto',
          gap: 10,
        }}
      >
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>Plant :</Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>

        {/* <Label>Plant :</Label> */}
        <Select
          value={insertData.plantId}
          data-cy="plant"
          style={{ width: '100%' }}
          onChange={value => {
            if (value !== 'ALL')
              setInsertData({
                ...insertData,
                plantId: value,
                entityId: entityPlantMap[value],
              })
            else
              setInsertData({
                ...insertData,
                plantId: 'ALL',
                entityId: 'ALL',
              })
          }}
        >
          <Select.Option key="ALL" value="ALL" data-cy="plant">
            ALL
          </Select.Option>
          {plantList.map(d => (
            <Select.Option key={d.plantId} data-cy="plant">
              {d.plantId}-{d.plantName}
            </Select.Option>
          ))}
        </Select>

        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Release Until :
          </Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        {/* <Label>Release Until :</Label> */}
        <DatePicker
          style={{ width: '100%' }}
          data-cy="releaseuntil"
          format="MM/DD/YYYY"
          value={moment(insertData.releaseDate)}
          onChange={releaseDateMom => {
            setInsertData({
              ...insertData,
              releaseDate: releaseDateMom.format('YYYY-MM-DD'),
            })
          }}
        />

        <Button type="primary" onClick={() => onAdd(true)}>
          Add
        </Button>
        <Button type="primary" onClick={() => onAdd(false)}>
          Add & Hide
        </Button>
        <Button type="danger" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    )
  }

  const Wind2LockHeaders = [
    // strCol({
    //   ident: 'entityId',
    //   display: 'Entity ID',
    //   isKey: true,
    //   width: 150,
    //   sortOrder: 'asc',
    //   ...toSelectionColProps(entityIdNameMap),
    // }),
    strCol({
      ident: 'plantId',
      display: 'Plant',
      isKey: true,
      sortOrder: 'asc',
      width: 300,
      isRequired: true,
      ...toSelectionColProps(PlantIdMap),
      sortIndexGetter: ({ rowData }) =>
        rowData.plantId === 'ALL'
          ? 1
          : PlantIdMap[rowData.plantId] || rowData.plantId,
    }),
    dateCol({
      ident: 'releaseDate',
      display: ' Release Until',
      isFiltered: true,
      isKey: true,
      sortOrder: 'desc',
    }),
    modifierCol,
    modifiedDateCol,
  ]
  const saveDays = _ => {
    setIsenableForUpdate(false)
    updateWind2LockDays(apiTargetInfo)(lockOutDays).fork(setError, _ => {
      retrieveDays()
    })
  }
  const extraCriteriaAfterButton = _ => (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'auto auto 200px',
        gap: '5px',
        alignItems: 'center',
      }}
    >
      <Label>
        <b>Lock Out Days : </b>
      </Label>

      <InputNumber
        min={0}
        // max={120}
        defaultValue={120}
        onChange={setLockOutDays}
        value={lockOutDays}
        disabled={!enableForUpdate}
      />
      {!enableForUpdate && (
        <Button
          icon="edit"
          type="primary"
          onClick={_ => setIsenableForUpdate(true)}
        >
          Enable For Update
        </Button>
      )}

      {enableForUpdate && (
        <Button icon="edit" type="primary" onClick={saveDays}>
          Save
        </Button>
      )}
    </div>
  )

  return (
    <CommonScreen
      extraCriteriaAfterButton={extraCriteriaAfterButton}
      title={title}
      header={Wind2LockHeaders}
      saveTask={updateWind2Lockcheck}
      retrieveTask={getWind2Lockcheck}
      deleteTask={deleteWind2Lockcheck}
      autoRetrieve
      // widthOffset={50}
      insertComp={insertEvent && InsertComp}
      insertCompHeight={50}
      onInsertEvent={b => setInsertEvent(b)}
      autoFixColByKey={false}
      headerRowHeight={30}
      totalWidth={150 + 650 + 400 + 150}
      sortOptions={Wind2LockHeaders}
      defaultInsertData={{ releaseDate: moment().format('YYYY-MM-DD') }}
      altBy={d => d.plantId}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(Wind2LockCheck)
